import React from 'react'
import { Check } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const ExerciseSelector = ({ exercises, selectedName, onSelect }) => {
  const { i18n } = useTranslation()
  return (
    <div className="grid grid-cols-3 gap-2 mb-4 max-h-80 overflow-y-auto pr-1 custom-scrollbar">
      {exercises.map((exercise) => {
        const displayName = (i18n.language === 'en' && exercise.en_name) ? exercise.en_name : (exercise.name || exercise.en_name)
        const isSelected = selectedName === displayName || selectedName === exercise.name // Handle both for safety
        return (
          <button
            key={exercise.id}
            type="button"
            onClick={() => onSelect(displayName)}
            className={`relative group flex flex-col items-center p-2 rounded-xl transition-all border-2
              ${isSelected ? 'border-orange-500 bg-orange-500/10' : 'border-gray-800 bg-[#2c2c2e] hover:border-gray-600'}
            `}
          >
            <div className="w-full aspect-square rounded-lg overflow-hidden mb-2 bg-[#1c1c1e] flex items-center justify-center relative">
              {exercise.image_url ? (
                <img src={exercise.image_url} alt={exercise.name} className="w-full h-full object-cover" />
              ) : (
                <img src="/no-image.png" alt="No Image" className="w-full h-full object-cover opacity-50" />
              )}

              {isSelected && (
                <div className="absolute inset-0 bg-orange-500/20 flex items-center justify-center">
                  <div className="bg-orange-500 rounded-full p-1">
                    <Check size={16} className="text-black" strokeWidth={3} />
                  </div>
                </div>
              )}
            </div>
            <span className={`text-xs font-bold text-center w-full truncate px-1
               ${isSelected ? 'text-orange-500' : 'text-gray-300'}
            `}>
              {displayName}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default ExerciseSelector
